import React from 'react';

const Features = props => (
  <div>
    <div className="business-features-3x">
      <div className="colourful-features-content">
        <div className="row">
          {props.features.map(feature => (
            <div className="col-md-3 no-padding" key={feature.id}>
              <div className={feature.style}>
                <h2>{feature.title}</h2>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* <div className="padding-top-large" /> */}
  </div>
);

export default Features;



// WEBPACK FOOTER //
// ./src/components/Features.js